// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_List = require("@rescript/runtime/lib/js/Stdlib_List.js");
let LotSizeUtils = require("./LotSizeUtils.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let PropertyAttributes = require("../../cap/Property/components/PropertyAttributes.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let LotPropertyAttributes_lotProperty_graphql = require("../../../__generated__/LotPropertyAttributes_lotProperty_graphql.bs.js");

let convertFragment = LotPropertyAttributes_lotProperty_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, LotPropertyAttributes_lotProperty_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(LotPropertyAttributes_lotProperty_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, LotPropertyAttributes_lotProperty_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(LotPropertyAttributes_lotProperty_graphql.node, convertFragment, fRef);
}

let PropertyTypeFragment_lotSizeUnit_decode = LotPropertyAttributes_lotProperty_graphql.Utils.lotSizeUnit_decode;

let PropertyTypeFragment_lotSizeUnit_fromString = LotPropertyAttributes_lotProperty_graphql.Utils.lotSizeUnit_fromString;

let PropertyTypeFragment = {
  lotSizeUnit_decode: PropertyTypeFragment_lotSizeUnit_decode,
  lotSizeUnit_fromString: PropertyTypeFragment_lotSizeUnit_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function LotPropertyAttributes(props) {
  let match = RescriptRelay_Fragment.useFragment(LotPropertyAttributes_lotProperty_graphql.node, convertFragment, props.propertyType);
  let lotSizeV2 = match.lotSizeV2;
  let attributes = Stdlib_List.filterMap({
    hd: [
      props.displayPropertyType ? match.displayName : undefined,
      "Empty"
    ],
    tl: {
      hd: [
        Stdlib_Option.map(lotSizeV2, v => LotSizeUtils.formatValue(v.value)),
        Stdlib_Option.map(lotSizeV2, v => LotSizeUtils.suffixFromUnit(v.unit))
      ],
      tl: /* [] */0
    }
  }, param => {
    let snd = param[1];
    let fst = param[0];
    if (fst !== undefined && snd !== undefined) {
      return [
        fst,
        snd
      ];
    }
  });
  return JsxRuntime.jsx(PropertyAttributes.make, {
    propertyAttributes: attributes,
    size: props.size
  });
}

let make = LotPropertyAttributes;

exports.PropertyTypeFragment = PropertyTypeFragment;
exports.make = make;
/* LotSizeUtils Not a pure module */
